<template>
  <li class="list__item">
    <Card :item="item">
      <!-- Image -->
      <template v-slot:image>
        <div class="card__bg-image" :style="{ 'background-image': 'url(' + item.previews + ')' }"></div>
      </template>

      <!-- Default -->
      <template>
        <!-- List -->
        <ul class="list">
          <li class="list__item flex valign-center color-gray">
            <i class="material-icons m-r-1">person</i>
            <span class="color-gray" v-if="item.modified_by">{{ item.modified_by.first_name }} {{ item.modified_by.last_name }}</span>
          </li>
          <li class="list__item flex valign-center color-gray">
            <i class="material-icons m-r-1">business</i>
            <span class="color-gray font--small" v-if="item.modified_by">{{ item.modified_by.company.name }}</span>
          </li>
          <li class="list__item flex valign-center color-gray">
            <i class="material-icons m-r-1">history</i>
            <span class="color-gray font--small" v-if="item.modified_on">{{ $d(new Date(item.modified_on), 'short') }}</span>
          </li>
        </ul>
      </template>

      <!-- Footer -->
      <template v-slot:footer>
        <el-button type="default" size="mini" :title="$t('Edit')" @click="onClickEdit(item)">
          <i class="material-icons">create</i>
        </el-button>
        <a
          :href="'https://pdf.pitchprint.io?id=' + item.project_id"
          target="_blank"
          class="el-button el-button--default el-button--mini el-button--plain"
          :title="$t('Download')"
        >
          <i class="material-icons">get_app</i>
        </a>

        <!-- Download Dropdown -->
        <!-- <el-dropdown trigger="click" class="m-l-small m-r-small">
          <el-button
            class="el-dropdown-link p-r-small"
            type="default"
            size="mini"
            :title="$t('Delete')"
          >
            <i class="material-icons">get_app</i>
            <i class="material-icons">arrow_drop_down</i>
          </el-button>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <a
                :href="'https://pdf.pitchprint.io?id=' + item.project_id"
                target="_blank"
                :title="$t('Download')"
              >{{ $t('Download as PDF') }}</a>
            </el-dropdown-item>

            <el-dropdown-item>
              <a
                :href="'https://pdf.pitchprint.io?id=' + item.project_id + '&raster=1'"
                target="_blank"
                :title="$t('Download')"
              >{{ $t('Download as PNG') }}</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>-->

        <el-button type="default" size="mini" :title="$t('Delete')" @click="onClickDelete(item)">
          <i class="material-icons">delete</i>
        </el-button>
      </template>
    </Card>
  </li>
</template>

<script>
import { PERSONALIZE_DESIGN } from '@/router/route-types';
import Card from '@/components/Card/Card';

export default {
  name: 'ListProjectsItem',

  components: {
    Card
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  methods: {
    doDeleteItem(id) {
      console.log('doDeleteItem', id);

      return this.$store
        .dispatch('project/DELETE_PROJECT', { id: id })
        .then(response => {
          console.log('--', response);

          if (response.hasOwnProperty('code')) {
            this.$notify({
              message: response.message,
              type: 'error',
              showClose: true,
              duration: 8000
            });
          } else {
            this.$notify({
              message: this.$t('Item has been successfully deleted'),
              type: 'success',
              showClose: true,
              duration: 8000
            });
          }

          return response;
        })
        .catch(err => {
          return err;
        });
    },

    onClickDelete(item) {
      this.$confirm(this.$t('Would you really like to delete this item?'), this.$t('Warning'), {
        confirmButtonText: this.$t('OK'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      })
        .then(() => {
          console.log(item.project_id);
          this.doDeleteItem(item.id);
        })
        .catch(() => {
          //
        });
    },

    onClickEdit(item) {
      this.$router.push({
        name: PERSONALIZE_DESIGN,
        params: { id: item.design_id },
        query: { project_id: item.project_id, id: item.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.list__item {
  max-width: 18rem;

  &:first-child {
    margin-top: 0.3rem !important;
  }
}
</style>
